



































































import VueOptions from '@utils/VueOptions'
import LogoSelector from '@ui/LogoSelector'
import countries from '@assets/countries.json'

settings = 
  name: 'POILocationForm'
  components: { LogoSelector }

  vue:  
    props: ['location']

    data: ->
      countriesData: countries
      extraKey: ''
      extraValue: ''

    computed:
      extraData: -> @location.data || {}
      extraDataTable: -> Object.entries(@extraData).map(([key, value]) => ({ key, value }))

    methods:
      hiAddExtraData: ->
        return if !@extraKey.length || !@extraValue.length
        @location.data[@extraKey] = @extraValue
        @syncExtraData()
        @extraKey = ''
        @extraValue = ''

      hiRemoveExtraData: (extraData) ->
        delete @location.data[extraData.key]
        @syncExtraData()

      syncExtraData: -> @location.data = { ...@location.data }

export default VueOptions.vue settings
